"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonSegmentedFilter = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
function OktonSegmentedFilter({ value, onChange, options, isDisabled, }) {
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    return (react_2.default.createElement(react_1.Flex, { borderWidth: "1px", p: "2", rounded: "2xl", bg: bg },
        react_2.default.createElement(react_1.HStack, { spacing: 2 }, options.map(option => (react_2.default.createElement(react_1.Button, { key: option.value, borderWidth: "2px", variant: value === option.value ? 'solid' : 'outline', isDisabled: isDisabled || option.isDisabled, onClick: () => onChange(option.value) }, option.label))))));
}
exports.OktonSegmentedFilter = OktonSegmentedFilter;
//# sourceMappingURL=SegmentedFilter.js.map